export const perfConfig = {
    DEBUG: {
        ENABLE_STATS: true
    }
};
